<template>
  <div v-if="project != null">
    <button
      type="button"
      class="btn btn-primary d-none"
      id="miw-project-icons-trigger"
      tabindex="-1"
      aria-hidden="true"
      data-toggle="modal"
      data-target="#miw-project-icons-modal"
    >
      icons
    </button>

    <div
      class="modal fade"
      id="miw-project-icons-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="miw-project-icons-label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="miw-project-icons-label">آیکون‌های پروژه</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row text-center">
              <div class="col" v-for="(image, idx) in (project.images || [])" :key="idx">
                <img :src="`${image.file}?id=${generateRandomString()}`" class="project-image-size" alt="">
                <p>{{ imageType(image.file) }}</p>
              </div>
            </div>

            <form @submit.prevent="submit" class="d-block my-5">
              <div class="col my-3" v-for="type in iconTypes" :key="type">
                <div class="custom-file text-left">
                  <input
                    @change="imageFileHandler"
                    :data-image-type="type"
                    type="file"
                    class="custom-file-input"
                    :id="`miw-choose-icon-${type}`"
                  >
                  <label class="custom-file-label" :for="`miw-choose-icon-${type}`">
                    Choose {{ type }}
                  </label>
                </div>
              </div>

              <div class="text-center">
                <button class="btn btn-primary" type="submit">submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {generateRandomString} from "@/store/Modules/Site";

export default {
  name: "ProjectIcons",
  props: {
    project: {}
  },
  data() {
    return {
      projectIcons: {},
      iconTypes: ['svg', 'ico', 'png']
    }
  },
  methods: {
    generateRandomString,
    imageType(file) {
      return file.split('.').slice(-1)[0]
    },
    imageFileHandler(e) {
      const fileType = e.target.getAttribute('data-image-type')
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.projectIcons[fileType] = files[0]
    },
    submit() {
      let formData = new FormData();
      Object.keys(this.projectIcons).forEach(index => {
        formData.append(`image_${index}`, this.projectIcons[index]);
      })
      this.$store.dispatch('ProjectAlpha/setProjectIcons', formData)
    },
    openModal() {
      $('#miw-project-icons-modal').modal('show')
    }
  }
}
</script>

<style scoped>
.project-image-size {
  width: 80px;
  height: 80px;
}
</style>
